// import { apiGet, apiPost, apiPatch } from './index'
import { apiGet, apiPost } from './index'
// 会员中心
const viplists = (params) => apiGet('/api/Vip/viplists', params)// 会员卡列表
const invcode = (params) => apiGet('/api/Center/invcode', params)
const addOrder = (params) => apiGet('/api/Vip/addOrder', params)
const cards = (params) => apiGet('/api/Vip/myCards', params)
const hasEndTip = (params) => apiGet('/api/Vip/hasEndTip', params)
const giveToFriends = (params) => apiPost('/api/Vip/giveToFriends', params) // 个人中心首页获取客户信息，统计个数
const svipGiveLog = (params) => apiGet('/api/Vip/svipGiveLog', params) // 个人中心首页获取客户信息，统计个数
const financeList = (params) => apiGet('/api/Center/finance', params)// 获取积分列表，财务列表

const cusotm = (params) => apiGet('/api/Center/customSum', params)
const cusotmList = (params) => apiGet('/api/Center/custom', params)
const cusotmDetails = (params) => apiGet('/api/Center/customInfo', params)
const cusotmDetailsList = (params) => apiGet('/api/Center/customOrderLists', params)

const rechargeGetList = (params) => apiGet('/api/Recharge/addOrder', params)
const rechargePost = (params) => apiPost('/api/Recharge/addOrder', params)

const getWxPublicInfo = (params) => apiGet('/api/Center/getWxPublicInfo', params)

const getDefShareInfo = (params) => apiGet('/api/Other/getDefShareInfo', params)

const getSigelInfo = (params) => apiGet('/api/Single/info', params) // 单页

const uploadPic = (params) => apiPost('/api/upload/pictures', params)

const getIdCardInfo = (params) => apiGet('/api/Other/getIdCardInfo', params) //

const getAdapayAccount = (params) => apiGet('/api/Center/openAdapayAccount', params) //
const postAdapayAccount = (params) => apiPost('/api/Center/openAdapayAccount', params) //
const getWithdrawal = (params) => apiGet('/api/Recharge/withdrawal', params) //
const postWithdrawal = (params) => apiPost('/api/Recharge/withdrawal', params) //
const withdrawalLog = (params) => apiPost('/api/Recharge/withdrawalLog', params) //

const vipTypeInfo = (params) => apiGet('/api/Vip/VipTypeInfo', params) // 查看卡包权益

// 待结算
const finance = (params) => apiGet('/api/Center/finance', params)
// 待结算
const myNotSettleSum = (params) => apiGet('/api/Center/myNotSettleSum', params)

// 获取优惠券内容
const couponInfo = (params) => apiGet('/wine/UpLevel/couponInfo', params)

// 获取优惠券
const postUpCoupon = (params) => apiPost('/wine/UpLevel/getUpCoupon', params) //

// 获取个人优惠券
const coupon = (params) => apiGet('/api/Center/coupon', params) //

// 获取优惠券列表
const getVipIdCoupon = (params) => apiGet('/api/Vip/getVipIdCoupon', params) //
// 获取个人优惠券
const postVipIdCoupon = (params) => apiPost('/api/Vip/getUpCoupon', params) //

// 设置密码
const setPassword = (params) => apiGet('/api/Center/setPassword', params) //

export {
  invcode,
  viplists,
  addOrder,
  cards,
  hasEndTip,
  cusotm,
  cusotmList,
  giveToFriends,
  svipGiveLog,
  financeList,
  cusotmDetails,
  cusotmDetailsList,
  rechargeGetList,
  rechargePost,
  getWxPublicInfo,
  getDefShareInfo,
  getSigelInfo,
  uploadPic,
  getIdCardInfo,
  getAdapayAccount,
  postAdapayAccount,
  getWithdrawal,
  postWithdrawal,
  withdrawalLog,
  vipTypeInfo,
  finance,
  myNotSettleSum,
  couponInfo,
  postUpCoupon,
  coupon,
  getVipIdCoupon,
  postVipIdCoupon,
  setPassword
}



// WEBPACK FOOTER //
// ./src/api/person.js